export default __webpack_public_path__ + "static/media/eb89f2c4512b2af01672e4d00532709f.7f2938a1.png";